import { render, staticRenderFns } from "./text-page.vue?vue&type=template&id=c3aabbcc&scoped=true"
import script from "./text-page.vue?vue&type=script&lang=js"
export * from "./text-page.vue?vue&type=script&lang=js"
import style0 from "./text-page.vue?vue&type=style&index=0&id=c3aabbcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aabbcc",
  null
  
)

export default component.exports